import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=2818f01c&scoped=true"
import script from "@/components/chat/Chat.ts?vue&type=script&lang=ts&external"
export * from "@/components/chat/Chat.ts?vue&type=script&lang=ts&external"
import style0 from "@/components/chat/chat.scss?vue&type=style&index=0&id=2818f01c&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818f01c",
  null
  
)

export default component.exports